"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateDateStringFromLuxon = generateDateStringFromLuxon;
const eventr_interface_1 = require("../interfaces/eventr.interface");
const underscore_1 = require("underscore");
/**
 * Returns datestring with CC for real time not local.
 */
function generateDateStringFromLuxon(luxonDateTime, override) {
    /// Clone of input to be edited
    const luxonDateTimeToUse = luxonDateTime;
    if (override) {
        /// Should really fix this differently but is to deal with legacy datetimes.
        const timezone = (0, eventr_interface_1.getTimezoneNumber)(luxonDateTimeToUse.zoneName);
        const newDateString = generateDateStringFromLuxonStart(luxonDateTimeToUse) +
            'O' +
            ((0, underscore_1.isUndefined)(timezone) ? '' : timezone);
        return newDateString;
    }
    else {
        /// If not overridden, removes offset, new format, empty cc for default
        const newDateString = generateDateStringFromLuxonStart(luxonDateTimeToUse) + 'N';
        return newDateString;
    }
}
/**
 * Main to string function, yyyy/mm/ddThh/mm
 */
function generateDateStringFromLuxonStart(luxonDateTime) {
    const newDateString = ('000' + luxonDateTime.year).slice(-4) +
        '-' +
        ('0' + luxonDateTime.month).slice(-2) +
        '-' +
        ('0' + luxonDateTime.day).slice(-2) +
        'T' +
        ('0' + luxonDateTime.hour).slice(-2) +
        ':' +
        ('0' + luxonDateTime.minute).slice(-2);
    return newDateString;
}
